import { useState, useEffect, useCallback } from 'react';
import {
  getAudits,
  getTechnicalErrors,
  getAIRecommendations,
  getPositioningAnalyses,
} from '../api';
import { buildAuditFindings } from '../utils/auditFindings';

/**
 * Charge en une fois toutes les données d'un audit complet et construit le
 * modèle unifié de constats (buildAuditFindings).
 *
 * Source unique pour la page "État des lieux", les onglets et les exports.
 */
export default function useAuditFindings(slug, project) {
  const [model, setModel] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!slug || !project) return;
    setLoading(true);
    try {
      const [audits, technicalErrorsData, aiRecommendations, positioningList] = await Promise.all([
        getAudits(slug).catch(() => []),
        getTechnicalErrors(slug).catch(() => null),
        getAIRecommendations(slug).catch(() => null),
        getPositioningAnalyses(slug).catch(() => []),
      ]);
      setModel(
        buildAuditFindings({
          project,
          audits,
          technicalErrorsData,
          aiRecommendations,
          positioning: positioningList?.[0] || null,
          visualAudit: project?.visual_audit || null,
        }),
      );
    } catch {
      setModel(buildAuditFindings({ project }));
    } finally {
      setLoading(false);
    }
  }, [slug, project]);

  useEffect(() => {
    load();
  }, [load, project?.date_dernier_audit, project?.score_global]);

  return { model, loading, reload: load };
}
